import { ServiceFetch } from '../service-fetch'

export default class ReimbursementListModel extends ServiceFetch {
    getReimbursementBy = (data) => this.authFetch({
        url: 'reimbursement-list/getReimbursementListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
 
}